import Locales from '@root/bind.joinroot.com/src/services/i18n/locales';

const i18n = Object.keys(Locales).reduce((localesObj, locale) => ({
  ...localesObj,
  [locale]: Locales[locale],
}), {});

export default i18n;
